import { useState } from "react"

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import MuiCard from '@mui/material/Card'
import Checkbox from '@mui/material/Checkbox'
import Divider from '@mui/material/Divider'
import FormLabel from '@mui/material/FormLabel'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import Link from '@mui/material/Link'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'

const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  boxShadow:
      'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  [theme.breakpoints.up('sm')]: {
    width: '450px',
  },
  ...theme.applyStyles('dark', {
    boxShadow:
        'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}))

const SignInCard = ({ signInWithEmail }) => {

  const [email, setEmail] = useState("")
  const [infoMessage, setInfoMessage] = useState("")
  const [errorMessage, setErrorMessage] = useState("")

  const [emailError, setEmailError] = useState(false)
  const [emailErrorMessage, setEmailErrorMessage] = useState('')

  const validateInputs = () => {
    let isValid = true

    // Email validation
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setEmailError(true)
      setEmailErrorMessage('Please enter a valid email address.')
      isValid = false
    } else {
      setEmailError(false)
      setEmailErrorMessage('')
    }

    return isValid
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    if (!validateInputs()) return
    const { data, error } = await signInWithEmail(email)
    console.log('data', data)
    console.log('error', error)
    error ? setErrorMessage(`${error}`) : setErrorMessage(null)
    JSON.stringify(data) === JSON.stringify({
      user: null,
      session: null,
    }) ? setInfoMessage('Email de connexion envoyé') : setInfoMessage(null)
  }

  return (
      <Card variant="outlined">
        <Typography component="h1" variant="h4" sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}>
          Connexion
        </Typography>
        <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 2 }}
        >
          <FormControl>
            <FormLabel htmlFor="email">Adresse e-mail</FormLabel>
            <TextField
                error={emailError}
                helperText={emailErrorMessage}
                id="email"
                type="email"
                name="email"
                placeholder="louis.pasteur@orange.fr"
                autoComplete="email"
                autoFocus
                required
                fullWidth
                variant="outlined"
                color={emailError ? 'error' : 'primary'}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />
          </FormControl>
          {infoMessage && <Typography color="success">{infoMessage}</Typography>}
          {errorMessage && <Typography color="error">{errorMessage}</Typography>}
          <Button type="submit" fullWidth variant="contained">
            Se connecter
          </Button>
        </Box>
        <Divider>
          Ou
        </Divider>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography sx={{ textAlign: 'center' }}>
            Pas encore de compte ?{' '}
            <span>
            <Link href="/" variant="body2" sx={{ alignSelf: 'center' }}>
              Rejoindre la liste d'attente
            </Link>
          </span>
          </Typography>
        </Box>
      </Card>
  )
}

export default SignInCard
